import modelExtend from 'dva-model-extend'
import { message, Modal } from 'antd'
import { basicModel, UPDATESTATE, Uuid } from '@sisyphe/utils'
import * as api from '../services/login'
import { Toast } from 'antd-mobile'
import { isMobileBrowser } from 'utils/tools'
import { loginTips } from 'components'
import { getLocalhostDeviceId, loginRedirectUrl, onGeetest } from 'utils'

import qs from 'query-string'

// 检验提示
const tipTexts = {
  103: '系统检测到你是首次登录本页面，由于密码安全需要，需要您设置一个密码，否则无法访问系统，建议立即设置新的密码！',
  107: '您的密码已经连续90天未更改，由于密码安全需要，需要重新设置密码，否则无法访问系统，建议立即重新设置一个新的密码！',
}

const messageSuccess = msg => {
  isMobileBrowser() ? Toast.success(msg) : message.success(msg)
}

const messageToast = msg => {
  isMobileBrowser() ? Toast.fail(msg) : message.error(msg)
}

export default modelExtend(basicModel, {
  namespace: 'login',
  state: {
    phoneErrors: 0,
    limit: false,
  },
  reducers: {
    setPhoneErrors(state) {
      return { ...state, phoneErrors: 3 }
    },
  },
  effects: {
    *preLogin({ payload }, { call, put }) {
      try {
        const data = yield call(api.preLogin, payload)
        return data
      } catch (error) {
        return error
      }
    },
    /** 登录 */
    *login({ payload }, { call, put }) {
      const redirectUrl = loginRedirectUrl()
      const search = window.sessionStorage.getItem('search')
      let { applicationCode, clientId, protocol, scope, param, responseType } =
        qs.parse(search)
      let params = {
        ...payload,
        applicationCode: applicationCode || 'passport',
        returnUrl: redirectUrl,
        // 2023-06-29 新增 oauth2 相关的 5 个参数
        clientId,
        protocol,
        scope,
        param,
        responseType,
        deviceId: getLocalhostDeviceId(),
      }

      // 唤起极验登录
      if (!payload?.geeres && payload?.limit) {
        yield put({ type: 'onGeetest', payload: params })
      } else {
        let result = null
        try {
          let serverApi = logintype =>
            payload?.loginType === 'id' ? api[logintype] : api.phoneLogin
          // 双重登录
          if (payload?.doubleFactor) {
            let res = yield call(serverApi('preLogin'), params)
            return res
          } else {
            yield call(serverApi('idLogin'), params)
          }
        } catch (error) {
          // 检验密码未设置以及过期提示框
          if (['103', '107'].includes(error?.code)) {
            loginTips({
              content: tipTexts[error?.code],
              onOk() {
                let path = `${
                  isMobileBrowser() ? '/mobile' : ''
                }/reset-password?hideWxQuick=true`
                payload?.history.push(path)
              },
            })
          } else if (error.code === '301') {
            // 双重登录
            if (payload?.doubleFactor) {
              return error
            } else {
              // 是否需要信任设备
              if (error.data.unTrustDevice) {
                try {
                  const deviceId = yield new Promise((resolve, reject) => {
                    Modal.confirm({
                      title:
                        '系统提示当前登录设备是陌生设备，请确认是否信任此设备？确定后将不再提醒',
                      type: 'warning',
                      okText: '确定',
                      cancelText: '取消',
                      onOk() {
                        resolve(getLocalhostDeviceId())
                      },
                      onCancel: () => {
                        reject()
                      },
                    })
                  })
                  // 调用信任设备接口
                  yield call(api.addTrustDevice, {
                    deviceId: deviceId, // 设备ID
                    workId: error.data.workId, // 工号
                  })
                } catch (err) {}
              }
              // 301 跳转
              window.location.href = error.data.redirectUrl
            }
          } else {
            // 调用极验
            if (['104', '106', '108', '111'].includes(error.code)) {
              yield put({
                type: UPDATESTATE,
                payload: { limit: true },
              })
            }
            messageToast(error?.message || error)
          }
        }
        return result
      }
    },
    /** 极验 */
    *onGeetest({ payload }, { call, put }) {
      let geeres = yield call(onGeetest, {})
      if (!geeres) return false
      let defaultPayload = {
        ...payload,
        geetestChallenge: geeres?.geetest_challenge,
        geetestValidate: geeres?.geetest_validate,
        geetestSeccode: geeres?.geetest_seccode,
        geeres: true,
      }
      yield put({
        type: 'login',
        payload: defaultPayload,
      })
    },
    /** 发送短信验证码 */
    *sendSms({ payload }, { call, put }) {
      let geeres = yield call(onGeetest, {})
      if (!geeres) return false
      yield call(api.sendSms, {
        ...payload,
        geetestChallenge: geeres?.geetest_challenge,
        geetestValidate: geeres?.geetest_validate,
        geetestSeccode: geeres?.geetest_seccode,
      })
      messageSuccess('验证码发送成功')
      return true
    },
    /** 重置密码 */
    *resetPassword({ payload }, { call, put }) {
      yield call(api.resetPassword, payload)
      messageSuccess('重置密码成功！')
      return
    },
    /** 企业微信登录 */
    *qyWeChatLogin({ payload }, { call, put }) {
      // 2023-06-29 新增 oauth2 相关的 5 个参数
      const search = window.sessionStorage.getItem('search')
      let { clientId, protocol, scope, param, responseType } = qs.parse(search)
      payload = { ...payload, clientId, protocol, scope, param, responseType }
      try {
        yield call(api.qyWeChatLogin, payload)
      } catch (error) {
        console.log(error, 'adrrr')
        return error
      }
    },
    *calendar({ payload }, { call, put }) {
      const { data } = yield call(api.calendar, payload)
      return data
    },
    *logout({ payload }, { call, put }) {
      const { data } = yield call(api.logout, payload)
      return data
    },
    *tokenCheck({ payload }, { call, put }) {
      const { data } = yield call(api.tokenCheck, payload)
      return data
    },
    *addTrustDevice({ payload }, { call, put }) {
      const { data } = yield call(api.addTrustDevice, payload)
      return data
    },
  },
})
